<template>
	<div class="index">
		<div class="index-con">

			<div class="nav-lists border-green">
				<div class="nav-title bg-green">
					We need you to upload the Final paper
				</div>
				<div class="nav-lists-con">
					<div class="coll-lists sub-lists">
						<div class="coll-list">
							<p>
								<b>Conference</b>
							</p>
							<p>
								<b> Register type</b>
							</p>
							<p>
								<b>Total</b>
							</p>
							<p>
								<b>Paper id</b>
							</p>
							<p>
								<b>Final paper</b>
							</p>
						</div>
						<div class="coll-list" v-for="(item,index) in [1,2,3]" :key="index">
							<p> IDS 2024 </p>
							<p> </p>
							<p> {\"usd\":\"212.00\",\"cny\":\"0.00\"} USD </p>
							<p> aa </p>
							<p>
								<span class="pay-btn" @click="toOther('/uploadPaperDetail')">
									Click upload
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		methods: {
			toOther(con) {
				this.$router.push(con)
			},
		}
	}
</script>

<style scoped>
	.pay-btn {
		color: #fff;
		border-radius: 4px;
		background-color: #5bc0de;
		padding: 0 15px;
		cursor: pointer;
		/* width: 100px; */
		height: 30px;
		line-height: 30px;
		text-align: center;
		box-sizing: border-box;
		display: inline-block;
	}

	.nav-lists {
		margin-bottom: 20px;
		border: 1px solid #bce8f1;
		border-radius: 4px;
	}

	.coll-lists {
		border: 1px solid #ddd;
		border-bottom: 0;
		border-radius: 4px;
	}

	.coll-list {
		display: flex;
		border-bottom: 1px solid #ddd;
		align-items: center;
	}

	.coll-list:nth-of-type(2n),
	.coll-list:hover {
		background: #f9f9f9;
	}

	.coll-list p {
		flex: 1;
		box-sizing: border-box;
		border-right: 1px solid #ddd;
		height: 40px;
		display: flex;
		align-items: center;
		padding: 15px 0 15px 15px;
		box-sizing: border-box;
	}

	.coll-list p:nth-last-of-type(1) {
		border-right: 0;
	}

	.sub-lists .coll-list p:nth-of-type(2) {
		flex: 1.5;
	}

	.sub-lists .coll-list p:nth-of-type(3) {
		flex: 3;
	}

	.nav-title {
		color: #31708f;
		background-color: #d9edf7;
		border-bottom: 1px solid transparent;
		border-color: #bce8f1;
		padding: 10px 15px;
		border-top-left-radius: 3px;
		display: flex;
		align-items: center;
		border-top-right-radius: 3px;
	}

	.bg-green {
		color: #3c763d;
		background-color: #dff0d8;
		border-color: #d6e9c6;
	}

	.border-green {
		border-color: #d6e9c6;

	}

	.nav-title i {
		margin-right: 5px;
	}

	.nav-lists-con {
		padding: 20px;
		box-sizing: border-box;
	}


	.index-con {
		width: 1200px;
		margin: 0 auto;
		padding-top: 40px;
	}



	@media screen and (max-width: 768px) {
		.index-con {
			width: 100%;
		}

		.sub-lists .coll-list p {
			padding: 0 5px;
		}

		.sub-lists .coll-list p:nth-of-type(3),
		.sub-lists .coll-list p:nth-of-type(1) {
			display: none;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/login/uploadPaper.vue